import React from 'react';

const NotFound = () => {
    return (
    <div
    style={{
        height: window.innerHeight + "px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "30px"
    }}
    >
    <strong>404</strong>&nbsp;&nbsp;Not Found
    </div>
    );

};

export default NotFound;